module.exports = __webpack_public_path__ + "img/Group 54.36a50ade.png";